// import * as STD     from '@emersya/mpa-std-lib';
import CM           from '@emersya/mpa-components-manager-lib';
import EngineModule from '../../../EngineModule';

export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'standing-hangingSignCustomConfigurator',
	dependencies :     [
		'oms-basket',
		'viewer-planner'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	insertionPath :    null,
	generateComponentConfiguration() {
		return {};
	},
	async initialize() {
		app.addEventListener(
			'viewer-before-products-extensions-use',
			(event) => {
				const v = <Viewer> <any> event.target;
				const ext = () : Partial<Viewer.IProductExtension> => ({
					configuratorPrepare : CM.PropertyOperation.create({
						type :          'call',
						componentPath : app.component_getPath(),
						propertyPath :  'standingHangingSignCustomConfiguratorPrepare',
						parameters :    []
					}),
					configuratorGet :     CM.PropertyOperation.create({
						type :          'call',
						componentPath : app.component_getPath(),
						propertyPath :  'standingHangingSignCustomConfiguratorGet',
						parameters :    []
					})
				});
				const PEBI = v.productsExtensionById;
				PEBI[ '14PB01A' ] = Object.assign(<Viewer.IProductExtension> PEBI[ '14PB01A' ] || {}, ext());
				PEBI[ '14PB01B' ] = Object.assign(<Viewer.IProductExtension> PEBI[ '14PB01B' ] || {}, ext());
			},
			{
				isAtTarget : false,
				listener :   app /** ONLY MPA IS ALLOWED TO USE INVALID LISTENER! **/
			}
		);
	}
});
import Viewer       from '../../../components/viewer/Viewer/Viewer';
